import React from 'react';
import style from "./style.scss";
import CheckBox from '../../atoms/checkBox';

const AuditErrCheckBoxContainer = ({ item, ind, handleSelectErr }) => {
    return (
        <div className={style["optItem"]}>
            <CheckBox
                isChecked={item.value}
                label={item.name}
                key={ind + item.name}
                onChange={() => handleSelectErr(item, ind)}
            />
            {
                item.value ? item?.subnames?.map((subItem, subInd) => {
                    return (
                        <div className={style["subOptItem"]}>
                            <CheckBox
                                isChecked={subItem.value}
                                label={subItem.name}
                                key={ind + subInd + subItem.name}
                                onChange={() => handleSelectErr(item, ind, false, subItem, subInd)}
                            />
                        </div>
                    )
                }) : null
            }
        </div>
    )
}

export default AuditErrCheckBoxContainer